//Carousel for Home Page Featured Programs
$('.programs__carousel .carousel__container').slick({
  slidesToShow: 3,
  prevArrow: $('#program-prev'),
  nextArrow: $('#program-next'),
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

//Carousel for Home Page Featured Programs
$('.partners__carousel .carousel__container').slick({
  slidesToShow: 5,
  prevArrow: $('#partner-prev'),
  nextArrow: $('#partner-next'),
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

//Carousel for Home Page Featured Programs
$('.hero__slider').slick({
  slidesToShow: 1,
  fade: true,
  cssEase: 'linear',
  prevArrow: $('#home_carousel-prev'),
  nextArrow: $('#home_carousel-next'),
  autoplay: true,
  autoplaySpeed: 5000,
});



// WEBPACK FOOTER //
// ./js/carousels.js